/**
 * Escape キーで「いちばん最後に開いたもの」だけを閉じるための共通スタック。
 *
 * 開閉パネルやモーダルが入れ子・多重で開いても、Escape 1回で最前面の1つだけが
 * 閉じるようにする（全部いっぺんに閉じるのを防ぐ）。
 * document の keydown リスナーはスタック全体で1つだけ張る。
 */
type EscapeCloseHandler = () => void;

const handlers: EscapeCloseHandler[] = [];
let listening = false;

const handleKeyDown = (event: KeyboardEvent) => {
  if (event.key !== 'Escape' && event.key !== 'Esc') return;
  const top = handlers[handlers.length - 1];
  if (!top) return;
  event.stopPropagation();
  top();
};

/**
 * Escape で閉じるハンドラを登録する。戻り値の関数で登録を解除する。
 * 後から登録したものほど「前面」とみなし、Escape ではそこだけを閉じる。
 */
export function pushEscapeHandler(handler: EscapeCloseHandler): () => void {
  handlers.push(handler);
  if (!listening) {
    document.addEventListener('keydown', handleKeyDown);
    listening = true;
  }
  return () => {
    const index = handlers.lastIndexOf(handler);
    if (index >= 0) handlers.splice(index, 1);
    if (handlers.length === 0 && listening) {
      document.removeEventListener('keydown', handleKeyDown);
      listening = false;
    }
  };
}